import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Pages
import Presentation from './pages/Presentation';
import Historique from './pages/Historique';
import APropos from './pages/APropos';
import Contact from './pages/Contact';
import Activites from './pages/Activites';
import LoginRecolteur from './pages/LoginRecolteur';
import DashboardRecolteur from './pages/DashboardRecolteur';
import LoginMembre from './pages/LoginMembre';
import DashboardMembre from './pages/DashboardMembre';
import ScanCodeBarres from './pages/ScanCodeBarres';
import LoginAdmin from './pages/LoginAdmin';
import DashboardAdmin from './pages/DashboardAdmin';
import LoginGerer from './pages/LoginGerer';
import DashboardGerer from './pages/DashboardGerer';
import LoginFamille from './pages/LoginFamille';
import DashboardFamille from './pages/DashboardFamille';
import LoginFinances from './pages/LoginFinances';
import DashboardFinances from './pages/DashboardFinances';
import ConfirmationPaiements from './pages/ConfirmationPaiements';
import ConfirmationPaiementsFamille from './pages/ConfirmationPaiementsFamille';
import ConfirmationPaiementsFinances from './pages/ConfirmationPaiementsFinances';
import ConfirmationPaiementsFamilleFinances from './pages/ConfirmationPaiementsFamilleFinances';
import ListeMontantsPrint from './pages/ListeMontantsPrint';
import ListeMembresPrint from './pages/ListeMembresPrint';
import ListeRecolteursPrint from './pages/ListeRecolteursPrint';
import ListeCotisationsPrint from './pages/ListeCotisationsPrint';
import ListePaiementsPrint from './pages/ListePaiementsPrint';
import ListeMembresCotisationsPrint from './pages/ListeMembresCotisationsPrint';
import ListeMembresRecoltesPrint from './pages/ListeMembresRecoltesPrint';
import ListeFamillesPrint from './pages/ListeFamillesPrint';
import ViewLogs from './pages/ViewLogs';

// Composants de protection
import PrivateRoute from './components/PrivateRoute';
import PrivateRouteMembre from './components/PrivateRouteMembre';

// Composants de notification
import NotificationContainer from './components/NotificationContainer';
import { useNotifications } from './hooks/useNotifications';

function AppContent() {
  const { notifications, removeNotification } = useNotifications();

  return (
    <>
      <Router>
        <Routes>
          {/* Routes publiques */}
          <Route path="/" element={<Presentation />} />
          <Route path="/historique" element={<Historique />} />
          <Route path="/apropos" element={<APropos />} />
          <Route path="/activites" element={<Activites />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/scan" element={<ScanCodeBarres />} />
          
          {/* Routes de connexion */}
          <Route path="/login-recolteur" element={<LoginRecolteur />} />
          <Route path="/login-membre" element={<LoginMembre />} />
          <Route path="/login-admin" element={<LoginAdmin />} />
          <Route path="/login-gerer" element={<LoginGerer />} />
          <Route path="/login-famille" element={<LoginFamille />} />
          <Route path="/login-finances" element={<LoginFinances />} />
          
          {/* Route de débogage - Logs */}
          <Route path="/logs" element={<ViewLogs />} />
          
          {/* Routes protégées */}
          <Route 
            path="/recolteur/*" 
            element={
              <PrivateRoute requiredRole="recolteur">
                <DashboardRecolteur />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/recolteur/paiement/:membreId" 
            element={
              <PrivateRoute requiredRole="recolteur">
                <ConfirmationPaiements />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/confirmation-paiements-famille/:familleId" 
            element={
              <PrivateRoute requiredRole="admin">
                <ConfirmationPaiementsFamille />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/membre/*" 
            element={
              <PrivateRouteMembre>
                <DashboardMembre />
              </PrivateRouteMembre>
            } 
          />
          <Route 
            path="/admin/*" 
            element={
              <PrivateRoute requiredRole="admin">
                <DashboardAdmin />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/gerer/*" 
            element={
              <PrivateRoute requiredRole="gerer">
                <DashboardGerer />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/famille/*" 
            element={
              <PrivateRoute requiredRole="famille">
                <DashboardFamille />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/finances/*" 
            element={
              <PrivateRoute requiredRole="finances">
                <DashboardFinances />
              </PrivateRoute>
            }
          />
          <Route 
            path="/finances/paiement-membre/:membreId" 
            element={
              <PrivateRoute requiredRole="finances">
                <ConfirmationPaiementsFinances />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/finances/paiement-famille/:familleId" 
            element={
              <PrivateRoute requiredRole="finances">
                <ConfirmationPaiementsFamilleFinances />
              </PrivateRoute>
            } 
          />
          
          {/* Route pour l'impression des montants mensuels */}
          <Route 
            path="/admin/montants/print" 
            element={
              <PrivateRoute requiredRole="admin">
                <ListeMontantsPrint />
              </PrivateRoute>
            } 
          />
          
          {/* Route pour l'impression de la liste des membres */}
          <Route 
            path="/admin/membres/print" 
            element={
              <PrivateRoute requiredRole="admin">
                <ListeMembresPrint />
              </PrivateRoute>
            } 
          />
          
          {/* Route pour l'impression de la liste des récolteurs */}
          <Route 
            path="/admin/recolteurs/print" 
            element={
              <PrivateRoute requiredRole="admin">
                <ListeRecolteursPrint />
              </PrivateRoute>
            } 
          />
          
          {/* Route pour l'impression de la liste des cotisations */}
          <Route 
            path="/admin/cotisations/print" 
            element={
              <PrivateRoute requiredRole="admin">
                <ListeCotisationsPrint />
              </PrivateRoute>
            } 
          />
          
          {/* Route pour l'impression de la liste des paiements */}
          <Route 
            path="/admin/paiements/print" 
            element={
              <PrivateRoute requiredRole="admin">
                <ListePaiementsPrint />
              </PrivateRoute>
            } 
          />
          
          {/* Route pour l'impression de la liste des membres avec cotisations */}
          <Route 
            path="/admin/rapports/membres-cotisations/print" 
            element={
              <PrivateRoute requiredRole="admin">
                <ListeMembresCotisationsPrint />
              </PrivateRoute>
            } 
          />
          
          {/* Route pour l'impression de la liste des membres récoltés */}
          <Route 
            path="/admin/rapports/membres-recoltes/print" 
            element={
              <PrivateRoute requiredRole="admin">
                <ListeMembresRecoltesPrint />
              </PrivateRoute>
            } 
          />
          
          {/* Route pour l'impression de la liste des familles */}
          <Route 
            path="/admin/familles/print" 
            element={
              <PrivateRoute requiredRole="admin">
                <ListeFamillesPrint />
              </PrivateRoute>
            } 
          />
          
          {/* Route par défaut */}
          <Route path="/" element={<Navigate to="/scan" replace />} />
        </Routes>
      </Router>
      <NotificationContainer 
        notifications={notifications} 
        onRemove={removeNotification} 
      />
    </>
  );
}

function App() {
  return <AppContent />;
}

export default App;

